import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../src/assets/styles/styles.scss'
import './registerServiceWorker'

import vuetify from '@/plugins/vuetify' // path to vuetify export


import { gsap} from "gsap";
import { ExpoScaleEase, RoughEase, SlowMo } from "gsap/EasePack";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger, ExpoScaleEase, RoughEase, SlowMo);



Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  

  render: h => h(App)
}).$mount('#app')
